import { render, staticRenderFns } from "./veSbzcCdRevert.vue?vue&type=template&id=21e9d4c7&scoped=true"
import script from "./veSbzcCdRevert.vue?vue&type=script&lang=js"
export * from "./veSbzcCdRevert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e9d4c7",
  null
  
)

export default component.exports